export const DEALER_CLAIM_NUMBER_MAX_LENGTH = 9;
